import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { exceptionHandler } from '../../base/decorators';
import { getFormDataWithParamsFilterUndefined, toURLSearchParams } from '../../base/utils';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
var FileOperationRepo = /** @class */ (function () {
    function FileOperationRepo() {
    }
    FileOperationRepo.prototype.postImportFile = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var reqForm, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqForm = getFormDataWithParamsFilterUndefined({
                            folder_id: req.folderId,
                            operation_id: req.operationId,
                            cos_file_key: req.cosFileKey,
                            drive_file_id: req.driveFileId,
                            password: req.password,
                            appid: req.appid,
                            filename: req.filename,
                            verify_token: req.verifyToken,
                            async: req.async,
                            platform: req.platform,
                            preview: req.preview,
                            delete_drive_file: req.deleteDriveFile,
                            bind_scene: req.bindScene,
                            scene_type: req.sceneType,
                            scene_id: req.sceneId,
                            scene_file_id: req.sceneFileId,
                            appSource: req.appSource, // 这个 key 不用转平铺
                            createSource: req.createSource, // 这个 key 不用转平铺
                        });
                        url = "".concat(FileOperationRepo.cgiPaths.IMPORT_FILE, "?xsrf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf));
                        return [4 /*yield*/, networkRequest.post(url, reqForm)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
       * 查询进度
       * @route /v1/import/queryImportProgress
       * @wiki https://iwiki.woa.com/pages/viewpage.action?pageId=644194973
       */
    FileOperationRepo.prototype.queryImportProgress = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var reqParams, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqParams = toURLSearchParams(req);
                        url = "".concat(FileOperationRepo.cgiPaths.QUERY_IMPORT_PROGRESS, "?xsrf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf));
                        return [4 /*yield*/, networkRequest.post(url, reqParams)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FileOperationRepo.cgiPaths = {
        IMPORT_FILE: '/v1/import/file',
        QUERY_IMPORT_PROGRESS: '/v1/import/queryImportProgress',
    };
    __decorate([
        exceptionHandler()
        /**
           * 上传文件 (cos)
           * @route POST /v1/import/file
           * @wiki https://iwiki.woa.com/pages/viewpage.action?pageId=644194973
           */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FileOperationRepo.prototype, "postImportFile", null);
    return FileOperationRepo;
}());
export { FileOperationRepo };
